import type { SVGProps } from 'react';

const SvgAcademy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m20.93 8.65-.05-.1a1 1 0 0 0-.14-.2c-.03-.03-.05-.06-.08-.08a1 1 0 0 0-.22-.15c-.03-.01-.05-.03-.08-.04 0 0-.01 0-.02-.01l-7.99-3.01a1.05 1.05 0 0 0-.7 0l-8 3C3.26 8.21 3 8.58 3 9s.26.79.65.94L7 11.2v4.81c0 .16.04.31.11.45.05.1 1.32 2.55 4.89 2.55s4.84-2.45 4.89-2.55c.07-.14.11-.29.11-.45V11.2l2-.75v3.56c0 .55.45 1 1 1s1-.45 1-1v-5c0-.12-.03-.24-.07-.35zM15 15.71c-.29.39-1.15 1.29-3 1.29s-2.72-.91-3-1.29v-3.77l2.65.99a1.03 1.03 0 0 0 .7 0l2.65-.99zm-3-4.78L6.85 9 12 7.07 17.15 9z"
    />
  </svg>
);
export default SvgAcademy;
